import './index.scss';
import React from 'react';
import styled from 'styled-components';

const TooltipBody = styled.div``;

const getTutorialImg = (images, style) => {
  if (images.length > 1) {
    // width + 20 for margin left + right
    return (
      <div style={{ width: style.width + 20, height: style.height }}>
        <img
          className="dark-light-tutorial pr-10"
          src={images[0]}
          alt="tutorial-img"
        />
        <img
          className="dark-light-tutorial pl-10"
          src={images[1]}
          alt="tutorial-img"
        />
      </div>
    );
  } else {
    return <img src={images[0]} alt="tutorial-img" />;
  }
};

const Tooltip = props => {
  const {
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    onSkip,
    imgSrc,
    imgHeight,
    imgWidth,
  } = props;

  const optStyle = index === 1 ? { width: 'unset' } : { width: 130 };

  return (
    <TooltipBody {...tooltipProps}>
      <div className="joyride-overwrite-css">
        <div className="tutorial-modal">
          <div className="title">
            <div className="text d-flex align-items-center">
              <a className="d-flex">
                <i className="icon-play-button text-stock-chart fs-20 mr-8" />
              </a>
              {step.title}
            </div>
            <div className="close-button">
              <a href="#">
                <i
                  className="icon-close text-stock-chart"
                  onClick={() => onSkip()}
                />
              </a>
            </div>
          </div>
          <div className="modal-container">
            <div className="welcome-text">{step.content}</div>
            <div
              className="stock-img"
              style={{ height: imgHeight, width: imgWidth }}
            >
              {getTutorialImg(imgSrc, { height: imgHeight, width: imgWidth })}
            </div>
            <div className="tutorial-group-button">
              <div className="d-flex button-container" style={optStyle}>
                {index > 1 && (
                  <div className="tutorial-button skip" {...backProps}>
                    BACK
                  </div>
                )}
                {step.id === 7 && (
                  <div className="tutorial-button start" {...closeProps}>
                    CLOSE
                  </div>
                )}
                {continuous && step.id !== 7 && (
                  <div className="tutorial-button start" {...primaryProps}>
                    NEXT
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </TooltipBody>
  );
};

export default Tooltip;
